<template>

    <div class="flex sm:h-screen sm:content-center sm:items-center">
        <div class="container mx-auto">

            <div class="container mx-auto w-full sm:max-w-lg">
                <div class="bg-white sm:rounded-lg sm:shadow-xl">
                    <h3 class="text-3xl font-bold text-black text-center pt-4">Viral News Service</h3>
                    <p class="text-center">Your source for breaking news video.</p>

                    <div class="px-6 py-4 mt-8">
                        <!-- password reset message, success -->
                        <div class="bg-blue-600 mb-8 p-4 text-white" v-if="status == 'password_reset'">
                            <span>Your password has been successfully reset. You may now log in.</span>
                        </div>
                        <!-- errors -->
                        <div class="bg-red-600 mb-8 p-4 text-white" v-if="error">
                            <span>Invalid credentials</span>
                        </div>

                        <div class="block pb-8" data-children-count="1">
                            <label class="block text-gray-700 font-bold mb-2" :class="{'text-red-600': error}" for="email">Email</label>
                            <input class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none" :class="{'border-red-400 focus:border-red-600 text-red-600': error, 'focus:border-indigo-400': !error }" type="email" name="email" id="email" v-model="email" required @keyup.enter="loginButtonClicked">
                        </div>
                        <div class="block pb-6" data-children-count="1">
                            <label class="block text-gray-700 font-bold mb-2" :class="{'text-red-600': error}" for="password">Password</label>
                            <input class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none" :class="{'border-red-400 focus:border-red-600 text-red-600': error, 'focus:border-indigo-400': !error }" type="password" name="password" id="password" v-model="password" required @keyup.enter="loginButtonClicked">
                        </div>
                    </div>

                    <div class="bg-grey-100 border-t border-b border-grey-300 rounded-b-lg px-6 py-4">
                        <div class="flex justify-between items-center">
                            <div class="">
                                Need to <router-link class="text-blue-600 hover:text-blue-700 hover:underline" to="/password/reset">reset your password</router-link>?
                            </div>

                            <button class="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded py-2 px-6 focus:outline-none" v-on:click="loginButtonClicked">
                                <span v-if="!loggingIn">Login</span>
                                <span v-if="loggingIn"><i class="fa fa-circle-notch fa-spin logging-in"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <footer class="container mx-auto w-full sm:max-w-md mt-10">
                <div class="container mx-auto max-w-md text-center">
                    <p class="text-gray-500">
                        &copy; 2017-2019 — Viral News Service, LLC
                    </p>
                </div>
            </footer>
        </div>

    </div>

</template>

<script>

    import { mapState, mapActions } from 'vuex';

	export default {
        name: 'Login',
		data () {
			return {
                msg: 'Welcome to Your Vue.js App',
                email: null,
                password: null,
                loggingIn: false,
                error: false,
                status: null,
			}
        },
        mounted() {
            if(this.$route.query.status !== undefined) {
                this.status = this.$route.query.status
            }
        },
        methods: {
            ...mapActions([
                'login'
            ]),
            loginButtonClicked() {
                this.loggingIn = true;
                var self = this;

                this.login({email: this.email, password: this.password})
                    .then((response) => {
                        setTimeout(function() {
                            if(response == 400 || response == 401) {
                                self.error = true;
                                self.loggingIn = false;
                            } else {
                                self.loggingIn = false;
                                self.$router.replace(self.$route.query.redirect || '/')
                            }
                        }, 1500);
                    })
                    .catch((data) => {
                        this.error = data.message;
                        this.errors = data.errors || {};

                        setTimeout(function() {
                            self.loggingIn = false;
                        }, 1500);
                        
                    });
            }
        }
    }

</script>